import React from "react";
import Navbar from "../components/navbar";
import AboutImage from "../assets/about-image.webp";
import EaseCruise from "../components/easycruisingcard";
import Easecruisedata from "../components/EaseCruiseData";
import Josh from "../assets/josh.jpg";
import Tom from "../assets/Goh-Tow-Hong.jpg";
import Akansha from "../assets/akansha_cmo.jpg";
import Vinu from "../assets/vinu.jpg";
import Footer from "../components/Footer";
import star from "../assets/Group-29637.png" ;
import ScrolltoTop from "../components/ScrolltoTop";
import UTMHandler from "../components/UTMHandler";
import AutoShowModal from "../components/AutoShowModal";


const About =()=> {
    return(
        <>

        <UTMHandler/>
        
        <div className="about-navbar">
        <Navbar/>
        </div>

        <div className="about-container" >
            <div className="about-maincontent">
                <img src={AboutImage} alt="About-Int2cruises" />
                <div>
                    <h1>Dive Int2 All <br></br>Things Cruising</h1>
                    <p>Between booking and boarding, everything concerning cruise
holidays is now under one sail- from selecting the right cruise line
and cabin, to providing the best deals and payment plans, to
suggesting shore excursions-it all happens here.</p>

<p><span style={{fontSize:'1.2rem', color:'#164d55',fontFamily:'Neue haas grotesk medium'}}>Int2Cruises</span> is an all-in-one platform, bringing global cruise culture
to Asia. Whether you are on a lookout for a quick getaway, a
heartfelt reunion, or an office retreat-we'll find the right cruise
for you.</p>
                </div>
            </div>

          
            <img src={star} alt="int2cruises logo " className="star-style"/>
    
            <div className="easy-cruising" >
            <h2>Crusing Made Easy</h2>
          
            <div >
            <EaseCruise icon={Easecruisedata[0].icon} heading={Easecruisedata[0].heading} content={Easecruisedata[0].content} />
            <EaseCruise icon={Easecruisedata[1].icon} heading={Easecruisedata[1].heading} content={Easecruisedata[1].content} />
            <EaseCruise icon={Easecruisedata[2].icon} heading={Easecruisedata[2].heading} content={Easecruisedata[2].content} />
            </div>
            <div>
            <EaseCruise icon={Easecruisedata[3].icon} heading={Easecruisedata[3].heading} content={Easecruisedata[3].content} />
            <EaseCruise icon={Easecruisedata[4].icon} heading={Easecruisedata[4].heading} content={Easecruisedata[4].content} />
            <EaseCruise icon={Easecruisedata[5].icon} heading={Easecruisedata[5].heading} content={Easecruisedata[5].content} />
            </div>
            
            </div>


            <div className="intcrusies-team">
                <h3>Meet the Crew</h3>
                <p>We Know the Ropes. Founded by Interzign Travel and Technology Pvt. Ltd., Our Crew Sports a Stellar Lineup of Industry Experts.</p>
                
                <div className="Team-container">
                    <div>
                    <a href="https://www.linkedin.com/in/josh-wen-b0083428/" target="_blank" rel="noreferrer"  style={{textDecoration:'none' , display:'flex' , flexDirection:'column', gap:'1vh'}} >
                    <img src={Josh} alt="int2cruises team" ></img>
                    <h4>Josh</h4>
                    <p>Regional Director</p>
                    </a>
                    </div>

                    <div>   
                        <a href="https://www.linkedin.com/in/towhong-goh/" target="_blank" rel="noreferrer" style={{textDecoration:'none' , display:'flex' , flexDirection:'column', gap:'1vh'}} >
                    <img src={Tom} alt="int2cruises team" className="tomhong"></img>
                    <h4>Tow Hong</h4>
                    <p>Sales Manager</p>
                    </a>
                    </div>

                    <div> 
                    <a href="https://www.linkedin.com/in/akansha-agarwal-9414ba15/" target="_blank" rel="noreferrer"  style={{textDecoration:'none' , display:'flex' , flexDirection:'column', gap:'1vh'}}>
                    <img src={Akansha} alt="int2cruises team"></img>
                    <h4>Akansha</h4>
                    <p>Chief Marketing Officer</p>
                    </a>
                    </div>

                    <div> 
                    <a href="https://www.linkedin.com/in/vinu-vijay-74a9bb4a/" target="_blank" rel="noreferrer" style={{textDecoration:'none' , display:'flex' , flexDirection:'column', gap:'1vh'}} >  
                    <img src={Vinu} alt="int2cruises team"></img>
                    <h4>Vinu</h4>
                    <p>Head of Operations</p>
                    </a> 
                    </div>

                </div>

            </div>



        </div>
<ScrolltoTop/>

<AutoShowModal/>

        <Footer/>


        </>
    );
}

export default About;